import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ContactInquiriesPage from "@/pages/admin/ContactInquiriesPage";

export const Route = createFileRoute("/_admin/admin/contact-inquiries")({
  head: () => pageHead("Admin · Contact Inquiries", "AKIVA admin · contact inquiries portal.", "/admin/contact-inquiries", true),
  component: ContactInquiriesPage,
});
